"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18nPointsFormatClientImpl = /** @class */ (function () {
    function I18nPointsFormatClientImpl(configSet) {
        this.configSet = configSet;
    }
    I18nPointsFormatClientImpl.prototype.getPattern = function (context, weblabContext) {
        return this.configSet.getString("pattern", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return I18nPointsFormatClientImpl;
}());
exports.default = I18nPointsFormatClientImpl;
